import api from '../utils/api';

export const assetsService = {
  async listMine(scope) {
    const params = {};
    if (scope && scope !== 'all') params.scope = scope;
    const resp = await api.get('/assets/mine/', { params });
    return Array.isArray(resp?.data) ? resp.data : [];
  },

  async getQuota() {
    const resp = await api.get('/assets/quota/');
    return resp?.data || { used: 0, limit: 0, next_reset_iso: null };
  },

  async listMinePaged(scope, page = 1, pageSize = 24) {
    const params = { page, page_size: pageSize };
    if (scope && scope !== 'all') params.scope = scope;
    const resp = await api.get('/assets/mine/', { params });
    const data = resp?.data;
    if (data && typeof data === 'object' && Array.isArray(data.results)) {
      return data;
    }
    // Fallback: legacy list -> emulate paginated payload
    const arr = Array.isArray(data) ? data : [];
    const slice = arr.slice((page - 1) * pageSize, page * pageSize);
    const next = arr.length > page * pageSize ? 'legacy-next' : null;
    return { count: arr.length, next, previous: null, results: slice };
  },
  async finalize(payload) {
    const resp = await api.post('/assets/finalize/', payload);
    return resp?.data || null;
  },

  async deleteAsset(assetId) {
    await api.delete(`/assets/${assetId}/`);
    return true;
  },
};


